export function deleteLabel(applet, user) {
  return applet.author === user.login ? "Archive" : "Delete"
}
